import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDoc } from "firebase/firestore";
import { Button, Segment, Divider, Icon } from "semantic-ui-react";
import { closeModal, openModal } from "../../../app/common/modals/modalSlice";
import ModalWrapper from "../../../app/common/modals/modalWrapper";
import { dateFormatDeadline, convertAddressFull, createClientLegalName } from "../../../app/common/util/util";
import { dataFromSnapshot, fetchTransactionFromDb } from "../../../app/firestore/firestoreService";

export default function TaskViewModal({ task, hideNavigate, allowEdit }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState(null);

  useEffect(() => {
    if (!task.transactionId) return;
    let isMounted = true;
    getDoc(fetchTransactionFromDb(task.transactionId)).then((snapshot) => {
      if (isMounted) setTransaction(dataFromSnapshot(snapshot));
    });
    return () => {
      isMounted = false;
    };
  }, [task.transactionId]);

  function handleGoToTransaction() {
    dispatch(
      closeModal({
        modalType: "TaskViewModal",
      })
    );
    navigate(`/transactions/${task.transactionId}/overview`);
  }

  function handleEdit() {
    dispatch(
      openModal({
        modalType: "TaskForm",
        modalProps: { task: task },
      })
    );
  }

  return (
    <ModalWrapper size="small">
      <Segment>
        <div className="flex">
          <h3 className="zero bottom margin text blue">{task.title}</h3>
          {hideNavigate && allowEdit && (
            <Icon
              name="edit"
              color="blue"
              link
              onClick={() => handleEdit()}
              style={{ paddingTop: "3px", marginLeft: "10px" }}
            />
          )}
        </div>
        <Divider />
        {task.end && (
          <p>
            <b>Deadline:</b> {dateFormatDeadline(task.end)}
          </p>
        )}
        {task.transactionTitle && (
          <p>
            <b>For Transaction:</b> {task.transactionTitle}
          </p>
        )}
        {transaction?.address?.street && (
          <p>
            <b>Address:</b> {convertAddressFull(transaction.address)}
          </p>
        )}
        {transaction?.client && (
          <p>
            <b>Client:</b> {createClientLegalName(transaction)}
          </p>
        )}
        {/* {task.assignedTo && (
          <p>
            <b>Assigned To:</b> {task.assignedTo}
          </p>
        )} */}
        {task.description && (
          <p>
            <b>Description:</b> {task.description}
          </p>
        )}
        {!hideNavigate && (
          <Button
            fluid
            basic
            primary
            onClick={() => handleGoToTransaction()}
            content="View Transaction"
          />
        )}
      </Segment>
    </ModalWrapper>
  );
}
